import { render, staticRenderFns } from "./IndagineEpidemiologicaEdit.vue?vue&type=template&id=4969f313"
import script from "./IndagineEpidemiologicaEdit.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports